// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.ManualReviewMovements .ag-full-width-row .ag-cell-wrapper.ag-row-group,
.ManualReviewMovements .ag-header-cell,
.ag-header-group-cell {
  padding-left: 16px;
}

.ManualReviewMovements .gridPageSize {
  padding-left: 0px;
}

.ManualReviewMovements .ag-cell {
  padding-left: 15px;
}

.ManualReviewMovements,
.ManualReviewMovements .aggridbasecomponent {
  height: 100%;
}

.ManualReviewMovements {
  display: grid;
  grid-template-rows: auto 1fr;
  height: calc(100% - 1rem);
  gap: 1vh;
  margin-block-start: 1rem;
}

.ManualReviewMovements .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {
  border-left: none;
}

.ManualReviewMovements .headerSection {
  display: grid;
  grid-template-rows: auto auto;
}

.ManualReviewMovements .gridPageSizeHeader .gridRefreshDiv {
  margin: 0px;
}

@media (min-width: 1025px) and (max-width: 1360px) {
  .ManualReviewMovements {
    gap: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/features/manualReviewMovements/ManualReviewMovements.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.ManualReviewMovements .ag-full-width-row .ag-cell-wrapper.ag-row-group,\n.ManualReviewMovements .ag-header-cell,\n.ag-header-group-cell {\n  padding-left: 16px;\n}\n\n.ManualReviewMovements .gridPageSize {\n  padding-left: 0px;\n}\n\n.ManualReviewMovements .ag-cell {\n  padding-left: 15px;\n}\n\n.ManualReviewMovements,\n.ManualReviewMovements .aggridbasecomponent {\n  height: 100%;\n}\n\n.ManualReviewMovements {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: calc(100% - 1rem);\n  gap: 1vh;\n  margin-block-start: 1rem;\n}\n\n.ManualReviewMovements .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {\n  border-left: none;\n}\n\n.ManualReviewMovements .headerSection {\n  display: grid;\n  grid-template-rows: auto auto;\n}\n\n.ManualReviewMovements .gridPageSizeHeader .gridRefreshDiv {\n  margin: 0px;\n}\n\n@media (min-width: 1025px) and (max-width: 1360px) {\n  .ManualReviewMovements {\n    gap: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
